import React, { useState, useEffect } from 'react';
import { categoriesAPI } from '../utils/api';

const GetQuote = () => {
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        phone: '',
        category: '',
        product: '',
        details: ''
    });

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await categoriesAPI.getAll({ status: 'active' });
                setCategories(response.data || []);
            } catch (error) {
                console.error('Error fetching categories:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'category') {
            const category = categories.find(c => c._id === value || c.name === value);
            setSelectedCategory(category);
            setFormData({
                ...formData,
                category: value,
                product: '' // Reset product when category changes
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Quote Request:', formData);
        alert('Your quote request has been received. Our team will review it shortly.');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50/30 pt-16">
            {/* Header */}
            <div className="bg-white border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">
                        Request a Proposal
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Tell us about your project requirements, and our team will create a tailored solution for your business.
                    </p>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="p-8 sm:p-12">
                        <form onSubmit={handleSubmit} className="space-y-8">

                            {/* Section 1: Contact Info */}
                            <div>
                                <h3 className="text-lg font-bold text-gray-900 flex items-center mb-6 border-b pb-2">
                                    <span className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm mr-3">1</span>
                                    Contact Information
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none"
                                            placeholder="e.g. Michael Scott"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Company Name</label>
                                        <input
                                            type="text"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none"
                                            placeholder="e.g. Dunder Mifflin"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Work Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none"
                                            placeholder="michael@dundermifflin.com"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none"
                                            placeholder="(555) 123-4567"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Section 2: Product Requirement */}
                            <div>
                                <h3 className="text-lg font-bold text-gray-900 flex items-center mb-6 border-b pb-2">
                                    <span className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm mr-3">2</span>
                                    Product Requirement
                                </h3>
                                <div className="space-y-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Category</label>
                                            <select
                                                name="category"
                                                value={formData.category}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none bg-white"
                                                required
                                            >
                                                <option value="">Select a category</option>
                                                {loading ? (
                                                    <option disabled>Loading categories...</option>
                                                ) : (
                                                    categories.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat.name}
                                                        </option>
                                                    ))
                                                )}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Product (Optional)</label>
                                            <select
                                                name="product"
                                                value={formData.product}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none bg-white"
                                                disabled={!selectedCategory}
                                            >
                                                <option value="">Select a product</option>
                                                {selectedCategory && selectedCategory.products && selectedCategory.products.length > 0 ? (
                                                    selectedCategory.products.map((prod) => (
                                                        <option key={prod._id} value={prod._id}>
                                                            {prod.name}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option disabled>No products available</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">Additional Details</label>
                                        <textarea
                                            name="details"
                                            value={formData.details}
                                            onChange={handleChange}

                                            rows="5"
                                            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none resize-none"
                                            placeholder="Please describe any specific requirements, deadlines, or quantities..."
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className="pt-6 border-t border-gray-100 flex items-center justify-end">
                                <button
                                    type="button"
                                    onClick={() => window.history.back()}
                                    className="mr-6 text-gray-600 font-semibold hover:text-gray-900 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all text-lg"
                                >
                                    Submit Request
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="bg-gray-50 px-8 py-6 border-t border-gray-100 text-center text-sm text-gray-500">
                        <i className="fas fa-lock mr-2"></i> Your information is secure. We never share your details with third parties.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GetQuote;
